const credentials = {
    'ru':  "Индивидуальный предприниматель Крутильникова Вероника Васильевна\
    ИНН &#8203;773128405240\
    ОГРН&#8203; 318774600031011\
    Расч. сч.&#8203; 40802 810 7 0199 0000822\
    БИК&#8203; 044525593\n \
    Кор. сч.&#8203; 30101810200000000593",
    'kz': `ИП ЧАУСОВА ЖСН (БСН)/ИИН(БИН): 611012401095 БеК/КБе: 611012401095 19 Банктің атауы/Наименование Банка: БСК/БИК: АО \"Народный Банк Казахстана\" HSBKK
    Клиенттің шоттары/Расчетный счет клиента: KZ76601A861004183791 KZT`
    // 'kz':  "Индивидуальный предприниматель Крутильникова Вероника Васильевна\
    // ИНН &#8203;773128405240\
    // ОГРН&#8203; 318774600031011\
    // Расч. сч.&#8203; 40802 810 7 0199 0000822\
    // БИК&#8203; 044525593\n \
    // Кор. сч.&#8203; 30101810200000000593",
};

const docs = {
    'ru': {
        ofertaLink: '/static/oferta.pdf',
        confidentLink: '/static/confident.pdf',
        userAgreementLink: '/static/user_agreement.pdf'
    },
    'kz': {
        ofertaLink: '/static/oferta_kz.pdf',
        confidentLink: '/static/confident_kz.pdf',
        userAgreementLink: '/static/user_agreement_kz.pdf'
    }
}

export {
    credentials,
    docs
}
